import type { Guide, GuideRecordHint } from '../types';

/**
 * S-28.10-01 — wygląd z makiety (status 28.10.2026 pkt 3, decyzja użytkownika
 * 28.10.2026). Sam wygląd: kroki pokazują ekrany pierwszej partii — bank
 * zleceń, kartę zlecenia i pulpity. Nagrywarka tylko otwiera ekrany.
 */
const ORDER: GuideRecordHint = {
  description: 'dowolne zlecenie z banku',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide' },
};

export const guide: Guide = {
  flagKey: 'mockupLook',
  title: 'Nowy wygląd aplikacji',
  whatItDoes:
    'Nowy wygląd całej aplikacji: niebieski pasek górny, zaznaczona pozycja menu na jasnoniebieskim tle, sekcje kart w ramkach z niebieskim znacznikiem przy tytule, tabele z szarymi nagłówkami kolumn i podświetleniem wiersza, znaczniki stanów jako „pigułki”, liczniki pulpitów na szarym tle. Zmienia się tylko wygląd — funkcje i dane są te same. Tekst zawsze się mieści: zawija się albo ma dymek z pełną treścią.',
  audience: ['wszyscy użytkownicy'],
  presentationItems: ['S-28.10-01'],
  steps: [
    {
      route: '/user-offers',
      target: 'wsp-tresc',
      title: 'Bank zleceń',
      description:
        'Lista w ramce na białym tle, nagłówki kolumn szare i zawijane zamiast uciętych, wiersz podświetla się pod kursorem, stany zleceń jako „pigułki”. Pozycja „Zlecenia” w menu jest zaznaczona na jasnoniebiesko.',
      action: 'Otwórz „Zlecenia” w menu.',
      recorder: { account: 'ftl' },
    },
    {
      route: '/user-offers/:orderId/show',
      record: ORDER,
      target: 'order-section-*',
      title: 'Karta zlecenia',
      description:
        'Każda sekcja karty ma tytuł z niebieskim znacznikiem i linią pod spodem. Długie podpowiedzi przy tytułach mają dymek z pełną treścią.',
      action: 'Otwórz dowolne zlecenie z banku.',
      recorder: { account: 'ftl', demo: { kind: 'order', number: 'DEMO/2026/10/H03' } },
    },
    {
      route: '/ftl-planner-dashboard',
      target: 'ftl-planner-dashboard',
      title: 'Pulpity',
      description:
        'Liczniki pulpitów planisty, Team Leadera i Trade stoją na szarym tle z podpisem wersalikami i dużą liczbą — jak pasek podsumowania w makiecie.',
      action: 'Otwórz „Pulpit planisty” w menu.',
      recorder: { account: 'ftl' },
    },
  ],
};
